// Version is intentionally omitted so Classroom resolves the current version.
export const CROSS_LANG_REVIEW_GUIDELINES_URL =
  'https://learn.udacity.com/nd0143?partKey=fce2b4ed-15c1-4c57-bca1-f4b8749fdcf1&lessonKey=bff3f601-a77a-4802-a931-5b367f6952fb&conceptKey=0c451abe-2a92-41a2-b467-7a7f571c63cc';
